import React,{useRef,useEffect} from 'react';  
import ReactDom from 'react-dom';
import {
    Button,
    Container,
    Divider,
    Dropdown,
    Grid,
    Header,
    Icon,
    Image,
    List,
    Menu,
    Responsive,
    Segment,
    Sidebar,
    Visibility,
  } from 'semantic-ui-react'
  import LazyLoad from 'react-lazy-load';
  import useWindowDimensions from './UseWindowDimensions'
  import LargeImage from './LargeImage'
  import YouTube from 'react-youtube';
  import {BrowserRouter as Router,Switch,Route } from 'react-router-dom' 
  import Interactive from './pages/Interactive'
  import DualClass from './pages/DualClass'
  import AbilityPage from './pages/AbilityPage'
  import SupportPage from './pages/SupportPage'
  import ScreenshotPage from './pages/ScreenshotPage'
  import DetailsPage from './pages/DetailsPage'
  import CheckItOut from './components/CheckItOut'
  import ScrollToTop from './components/ScrollToTop'
  import MainMenu from './components/MainMenu'

  //earthquake:  https://im2.ezgif.com/tmp/ezgif-2-4c0f2e9d9b67.gif
const youtubeOptionsVerySmall = { height:300*(5/9),  width:300   }
const youtubeOptionsSmall = { height:480*(5/9),  width:480   }
const youtubeOptionsMedium = { height:900*(5/9),  width:900   }
const youtubeOptionsLarge = {  height:1200*(5/9),  width:1200   }
const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)  
function HomePage()
{
  const myRef = useRef(null)
  const executeScroll = () => scrollToRef(myRef)

  const { height, width } = useWindowDimensions();

  var youtubeOptions =  (width < 480 ? youtubeOptionsVerySmall :(width < 900 ? youtubeOptionsSmall: (width < 1200 ? youtubeOptionsMedium : youtubeOptionsLarge)))
  const fontSize = { fontSize:  width < 500 ? '1.00em' : '1.33em' } 

  var blue = '#2c3290'
 
  // console.log(width);

 
  
      return   <Router> 
        <ScrollToTop/>
        <Segment inverted> 
          <MainMenu></MainMenu> 
          <Switch>
        <Route exact path="/interactive" ><Interactive width={width} height={height} ></Interactive></Route>
        <Route exact path="/dualclass"  ><DualClass width={width} height={height}></DualClass></Route> 
        <Route exact path="/abilities"  ><AbilityPage width={width} height={height}></AbilityPage></Route>
        <Route exact path="/details"  ><DetailsPage width={width} height={height}></DetailsPage></Route>
        <Route exact path="/screenshots"  ><ScreenshotPage width={width} height={height}></ScreenshotPage></Route>
        <Route exact path="/support"  ><SupportPage width={width} height={height}></SupportPage></Route>
        <Route exact path="/" >

          <LazyLoad  height={100}>
          <LargeImage imageName="castle-moat-large.png" imageHeight={1244} imageWidth={1964} height={height} width={width}></LargeImage>
          </LazyLoad>
          <LazyLoad  height={200}>
          <LargeImage imageName="title-large.png" imageHeight={127} imageWidth={372 } height={height} width={width}></LargeImage>
          </LazyLoad>
          <LazyLoad  height={1244-10-300}>
            <div style={{paddingLeft:(width-300)/2}}> 
            <Button circular size='large' color='blue' onClick={executeScroll} >
                <Icon name='video play'></Icon>  
                Watch Trailer
              </Button>
              <Button circular size='large' color='blue' onClick={e=>{window.open('https://www.patreon.com/cascadetactics')}} >
                <Icon name='heart'></Icon>  
                Donate
              </Button>
              <Button circular size='large' color='blue' onClick={e=>{window.open('https://store.steampowered.com/app/1732800/Cascade_Tactics/')}} > 
                Find on Steam
              </Button>
            </div>
          </LazyLoad>
          <Divider></Divider> 
          <div style={{paddingLeft:(width-youtubeOptions.width)/2}}>
            
          <div ref={myRef}> </div> 
          <LazyLoad height={youtubeOptions.height}>
            <YouTube 
              videoId='zFIzzogVHuA'
              // videoId='K1UWN5f-v2Y' 
              opts = {youtubeOptions}
              onReady={(event)=>_onReady(event)}
            ></YouTube>
          </LazyLoad> 

          </div>
          <Divider></Divider> 
          <Container text> 
            <p  style={fontSize}>
              <i>Cascade Tactics</i> is a tactical RPG and a spiritual successor to <i>Final Fantasy Tactics</i> and <i>Tactics Ogre</i>.  
              Improve your team and progress through a series of turn-based battles on an isometric grid.  
            </p>
            <p style={fontSize}>Will be available on multiple platforms!</p>
          </Container>
          <Divider></Divider> 
        
          <CheckItOut></CheckItOut>
          
        </Route>
        </Switch>
        </Segment>
    </Router>
  //}
}
 
function _onReady(event) {
  // access to player in all event handlers via event.target
  // console.log(event);
  // console.log(event.target);
  // event.target.pauseVideo();
}
 

export default HomePage;